var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('auth-template', [_c('account-creating-animation', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }), _c('account-creating-poster', {
    attrs: {
      "slot": "poster"
    },
    slot: "poster"
  }), _c('template', {
    slot: "information"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('from.social.medias.to.site')))]), _c('p', [_vm._v(_vm._s(_vm.$t('common.green')))])]), _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    staticClass: "layout-background"
  }), _c('div', {
    class: _vm.$style.header
  }, [_c('auth-header', {
    attrs: {
      "title": _vm.$t('where.to.start.recieve.payments')
    }
  })], 1), _c('div', {
    class: _vm.$style.form
  }, [_c('account-creating-form', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "submit": _vm.handleSubmit
    }
  })], 1)])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }